import { Namespace } from '@wix/ambassador-metasite-api-v1-meta-site/types';
export const getIsBusinessFirst = metaSite => {
  var _metaSite$metaSite;
  return (metaSite == null || (_metaSite$metaSite = metaSite.metaSite) == null ? void 0 : _metaSite$metaSite.namespace) === Namespace.DASHBOARD_FIRST;
};
//# sourceMappingURL=metaSite.js.map